import { request } from "../libs";

function addServerDetails(domain, meta) {
	return request(
		`/server/${domain}/meta`,
		{
			method: "POST",
			body: JSON.stringify(meta)
		}
	)
		.then(res => res.statusCode);
}

export default addServerDetails;



// WEBPACK FOOTER //
// ./src/api/add-server-details.js